import { gql } from "@apollo/client";

export const CREATE_RECHARGE = gql`
mutation RechargeWalletBalance($amount: Float) {
  RechargeWalletBalance(amount: $amount) {
    success
    message
    paymentSessionId
  }
}
`